import { o_global } from "../chunks/common-namespaces-client-CHyZgmlk.mjs";
import { otto } from "../chunks/common-nexus-client-BxVeVD8v.mjs";
import { asExport } from "../chunks/common-core-client-BYCqsbss.mjs";
import { noop } from "../chunks/common-function-client-BVBvJr6Z.mjs";
const device = o_global.device ?? {};
const os = device.os;
const browser = device.browser;
const type = device.type;
const hybrid = device.hybrid;
const orientation = device.orientation;
const deviceAsync = /*           */ asExport(otto, "device", {});
const pointerType = /*           */ asExport(
  deviceAsync,
  "pointerType",
  {}
);
const getPointerType = /*           */ asExport(
  deviceAsync,
  "getPointerType",
  noop
);
const getScreenSpecs = /*           */ asExport(
  deviceAsync,
  "getScreenSpecs",
  noop
);
export {
  browser,
  device,
  deviceAsync,
  getPointerType,
  getScreenSpecs,
  hybrid,
  orientation,
  os,
  pointerType,
  type
};
/*                                      */
